module.exports = __webpack_public_path__ + "static/media/tablet-bg-layer-1.8d9b252a.png";